<!-- Mobile: Bottom Drawer -->
<p-drawer
  [visible]="isOpen && !isDesktop"
  position="bottom"
  [modal]="true"
  [style]="{ height: 'auto', maxHeight: '85vh' }"
  styleClass="synergy-drawer-mobile"
  (onHide)="onClose()"
  (visibleChange)="onVisibleChange($event)">

  <ng-template pTemplate="headless">
    <div class="synergy-sheet">
      <div class="synergy-sheet__handle"></div>
      <ng-container *ngTemplateOutlet="sheetContent"></ng-container>
    </div>
  </ng-template>
</p-drawer>

<!-- Desktop: Modal Dialog -->
<p-drawer
  [visible]="isOpen && isDesktop"
  position="right"
  [modal]="true"
  [style]="{ width: '480px' }"
  styleClass="synergy-drawer-desktop"
  (onHide)="onClose()"
  (visibleChange)="onVisibleChange($event)">

  <ng-template pTemplate="headless">
    <div class="synergy-sheet synergy-sheet--desktop">
      <div class="synergy-sheet__header">
        <span class="synergy-sheet__category">{{ getCategoryLabel(synergy?.category || '') }}</span>
        <button class="synergy-sheet__close" (click)="onClose()" type="button">
          <i class="pi pi-times"></i>
        </button>
      </div>
      <ng-container *ngTemplateOutlet="sheetContent"></ng-container>
    </div>
  </ng-template>
</p-drawer>

<!-- Shared Content Template -->
<ng-template #sheetContent>
  <div class="synergy-sheet__body" *ngIf="synergy">
    <!-- Avatars -->
    <div class="synergy-sheet__avatars">
      <div
        class="synergy-sheet__avatar"
        (click)="onAvatarClick(synergy.hub_1.id, $event)"
        [title]="synergy.hub_1.name + ' anzeigen'">
        <img *ngIf="synergy.hub_1.avatar" [src]="synergy.hub_1.avatar" [alt]="synergy.hub_1.name" />
        <div *ngIf="!synergy.hub_1.avatar" class="synergy-sheet__avatar-placeholder">
          <i class="pi pi-building"></i>
        </div>
      </div>
      <div
        class="synergy-sheet__avatar synergy-sheet__avatar--second"
        (click)="onAvatarClick(synergy.hub_2.id, $event)"
        [title]="synergy.hub_2.name + ' anzeigen'">
        <img *ngIf="synergy.hub_2.avatar" [src]="synergy.hub_2.avatar" [alt]="synergy.hub_2.name" />
        <div *ngIf="!synergy.hub_2.avatar" class="synergy-sheet__avatar-placeholder">
          <i class="pi pi-building"></i>
        </div>
      </div>
    </div>

    <!-- Title -->
    <h2 class="synergy-sheet__title">{{ synergy.hub_1.name }} & {{ synergy.hub_2.name }}</h2>

    <!-- Meta -->
    <div class="synergy-sheet__meta">
      {{ getCategoryLabel(synergy.category) }} · {{ synergy.hub_1.city }}
      <span *ngIf="synergy.activated_at"> · Aktiv seit {{ formatDate(synergy.activated_at) }}</span>
    </div>

    <!-- Description -->
    <p class="synergy-sheet__description" *ngIf="synergy.description">
      {{ synergy.description }}
    </p>

    <!-- Benefits -->
    <div class="synergy-sheet__benefits" *ngIf="synergy.potential_benefits?.length">
      <div
        class="synergy-sheet__benefit"
        *ngFor="let benefit of synergy.potential_benefits.slice(0, 4)">
        <span class="synergy-sheet__benefit-check">✓</span>
        <span>{{ benefit }}</span>
      </div>
    </div>
  </div>
</ng-template>
